import { handleFill } from '@/utils/util'
import dayjs from 'dayjs'

// 活动类型列表
export const activityTypeList = [
  { label: '全部', value: '' },
  { label: '抽奖', value: 1 }
]

// 活动举办周期列表
export const periodTypeList = [
  { label: '全部', value: '' },
  { label: '只办一次', value: 1 },
  { label: '每周重复', value: 2 },
  { label: '每月重复', value: 3 }
]

// 活动状态列表
export const statusTypeList = [
  { label: '全部', value: '', img: '', class: '' },
  { label: '待确认', value: 1, img: 'await-confirm.png', class: 'await-confirm' },
  { label: '等待开始', value: 2, img: 'await-start.png', class: 'await-start' },
  { label: '进行中', value: 3, img: 'running.png', class: 'running' },
  { label: '已关闭', value: 4, img: 'closed.png', class: 'closed' },
  { label: '已结束', value: 5, img: 'ended.png', class: 'ended' },
  { label: '未开启', value: 6, img: 'not-enabled.png', class: 'not-enabled' }
]

// 限制对象类型列表
export const limitTypeList = [
  { label: '新注册会员', value: 1 },
  { label: '现有会员', value: 2 }
]

// 奖品类型列表
export const prizeTypeList = [
  { label: '自定义奖品', value: 1 },
  { label: '积分', value: 2 }
]

// 默认奖品对象
export const defaultPrize = {
  prizeType: 1, // 奖品类型(1自定义2积分)
  sortNumber: 1, // 唯一，和限制对象奖品关联起来，不是排序作用，后端定的
  prizeName: '',
  prizePoint: '',
  prizeCost: '',
  prizeAmount: '',
  prizeWinRate: ''
}

// 默认限制对象
export const defaultLimit = {
  limitType: '', // 限制对象类型(1新注册会员2现有会员)
  sortNumber: '', // 和奖品关联起来，不是排序作用，后端定的
  limitTypeName: '',
  limitPrizeName: '',
  limitWinRate: ''
}

// 格式化日期
export function formatDate (date: string) {
  return handleFill(date ? dayjs(date).format('YYYY/MM/DD') : '')
}

// 格式化日期时间
export function formatDateTime (dateTime: string) {
  return handleFill(
    dateTime ? dayjs(dateTime).format('YYYY/MM/DD HH:mm:ss') : ''
  )
}

// 添加序号
export function arrAddSortNumber (arr: any) {
  return arr.map((item, index) => {
    return {
      sortNumber: index + 1, // 默认取item里面的sortNumber
      ...item
    }
  })
}